import { LocalStorageService } from '@/services/localStorageService';
import { LOCAL_STORAGE_KEYS } from '@/constants';

const TIER_1_GEO = [
	'US',
	'GB', // United Kingdom (ISO code returned by the geo-lookup API)
	'UK', // United Kingdom (alt, kept for parity with getGDPRAccess)
	'AU',
	'CA',
	'CH',
	'FR',
	'IT',
	'ES',
	'DE',
	'LU',
	'BE',
	'IE',
	'NL',
	'NO',
	'UA',
	'CY',
];

export const isTier1Geo = (): boolean => {
	const countryCode = LocalStorageService.get(
		LOCAL_STORAGE_KEYS.COUNTRY_CODE,
		'',
	);
	return !!countryCode && TIER_1_GEO.includes(countryCode);
};
